/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

const profileFormSlice = createSlice({
  name: 'profileForm',
  initialState: {
    hasPartner: false,
    data: {
      buckets: {},
    },
  },
  reducers: {
    setFlags: (
      state,
      { payload: { hasPartner } }: PayloadAction<{ hasPartner: boolean }>,
    ) => {
      state.hasPartner = hasPartner
    },
    setBuckets: (
      state,
      { payload: { bucket } }: PayloadAction<{ bucket: any }>,
    ) => {
      const { name, data, ...restBucket } = bucket
      state.data.buckets = {
        ...state.data.buckets,
        [name]: data,
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state = profileFormSlice.getInitialState()
    })
  },
})

export const { setFlags } = profileFormSlice.actions
export const { setBuckets } = profileFormSlice.actions

export default profileFormSlice.reducer
